import { message, notification } from "antd";
import { IconType } from 'antd/lib/notification';
interface FilrResponse {
    retCode: number,
    retData: string,
    retMsg: string,
    success: boolean,
    [key: string]: any

}
interface File {
    uid?: string,
    name?: string,
    status?: string,
    response: FilrResponse,
    linkProps?: any
}
interface Upload {
    file: File,
    fileList: any,
    event: any
}

export const messageConfig = (content: string, duration: number, type: IconType) => {
    notification.open({
        description: "",
        message: content,
        duration: duration,
        type: type,
        style: {
            width: 900,
        },
        placement: "topRight"
    })
}

export function importPropsConfig1(url: string, callback: any, loadingFn?: () => void, isMessage = true): object {
    let cfg = {
        name: 'file',
        //这个属性必须写,针对手动上传
        beforeUpload: (file: any) => {
            return false;
        },
        onChange(info: Upload) {
            loadingFn?.();
            try {
                callback?.(info.file);
                // if (info.file.status === 'done' && info.file.response) {
                //     isMessage && messageConfig(`${info.file.name}导入${typeof info.file.response.retData === "string" ? info.file.response.retData : info.file.response.retMsg}`, 20, "info");
                //     // message.info(`${info.file.name}导入${typeof info.file.response.retData === "string" ? info.file.response.retData : info.file.response.retMsg}`, 20);
                //     callback?.(info.file);
                // } else if (info.file.status === 'error' && info.file.response && info.file.response.retData) {
                //     isMessage && messageConfig(`${info.file.response.retData}：${info.file.name}导入异常，请尝试重新导入`, 20, "error");
                //     // message.error(`${info.file.response.retData}：${info.file.name}导入异常，请尝试重新导入`, 20);
                //     callback?.(undefined);
                // } else if (info.file.status === 'error') {
                //     message.error("导入错误");
                //     callback?.(undefined);
                // }
                // else if (!info.file.status) {
                //     callback?.(undefined);
                // }
            } catch (error) {
                message.warning("导入异常，请重新尝试");
                callback?.(undefined);
            }
        },
    }
    return cfg
}